<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-toolbar dark color="primary" max-height="60">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <vendor
          :singlePage="true"
          :showGrid1="false"
          @select="select"
          @closeDialog="closeDialog"
          :showSelectBtn="true"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import Vendor from "@/views/vendor/Vendor.vue";

@Component({
  name: "VendorCreate",
  components: {
    Vendor,
  },
  props: {
    showDialog: {
      default: false,
    },
  },
})
export default class VendorCreate extends Vue {
  dialog = false;

  hideMe() {
    this.$emit("dialogUpdate", false);
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("select", null);
  }

  select(data) {
    this.$emit("select", data);
  }
}
</script>
